import { create, skipWhen } from "vest";

import { isSerializedProduct } from "utils/products.utils";
import {
  dateIsValid,
  maxNumber,
  minNumber,
  required
} from "utils/validations.utils";

import { productTypeHasSubtype } from "./constants";
import { InventoryProductValues } from "./inventory-product-form.component";

export type InventoryProductFieldName =
  | "type"
  | "subtype"
  | "product"
  | "clinic"
  | "serial_number"
  | "quantity"
  | "condition"
  | "manufacturer_warranty_expiration_date"
  | "loss_damage_warranty_expiration_date"
  | "manufacturer_return_date";

export const inventoryProductValidator = () =>
  create((data: InventoryProductValues) => {
    const {
      clinic,
      quantity,
      serial_number,
      type,
      subtype,
      product,
      manufacturer_warranty_expiration_date,
      loss_damage_warranty_expiration_date,
      manufacturer_return_date
    } = data;

    skipWhen(!manufacturer_warranty_expiration_date, () => {
      dateIsValid<InventoryProductFieldName>(
        "manufacturer_warranty_expiration_date",
        "Date",
        manufacturer_warranty_expiration_date
      );
    });

    skipWhen(!manufacturer_return_date, () => {
      dateIsValid<InventoryProductFieldName>(
        "manufacturer_return_date",
        "Date",
        manufacturer_return_date
      );
    });

    skipWhen(!loss_damage_warranty_expiration_date, () => {
      dateIsValid<InventoryProductFieldName>(
        "loss_damage_warranty_expiration_date",
        "Date",
        loss_damage_warranty_expiration_date
      );
    });

    const isSerialized = isSerializedProduct(
      Number(type),
      Number(subtype),
      false
    );
    skipWhen(!isSerialized, () => {
      required<InventoryProductFieldName>(
        "serial_number",
        "Serial Number",
        serial_number
      );
      maxNumber<InventoryProductFieldName>("quantity", "Quantity", quantity, 1);
    });

    required<InventoryProductFieldName>("type", "Type", type);

    skipWhen(!productTypeHasSubtype(type), () => {
      required<InventoryProductFieldName>("subtype", "Subtype", subtype);
    });

    required<InventoryProductFieldName>("product", "Product", product);
    required<InventoryProductFieldName>("clinic", "Clinic", clinic);
    required<InventoryProductFieldName>("quantity", "Quantity", quantity);
    minNumber<InventoryProductFieldName>("quantity", "Quantity", quantity, 0);
  });
